import { __assign, __rest } from "tslib";
import * as React from 'react';
function getSize(size) {
    if (size === 'sm') {
        return 16;
    }
    else if (size === 'md') {
        return 24;
    }
    else if (size === 'lg') {
        return 32;
    }
    else if (size === 'tool') {
        return 26;
    }
    return 24;
}
export function Icon(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    if (!React.isValidElement(children)) {
        return null;
    }
    return React.cloneElement(children, __assign(__assign({ 'aria-hidden': true, 'data-qa': "ci-".concat(props.name) }, props), { width: getSize(props.size), height: getSize(props.size), focusable: false, style: __assign(__assign({}, props.style), { flex: '0 0 auto' }) }));
}
